enum TextCtaType {
  CancelPreOrder = 'CancelPreOrder',
  Default = 'Default'
}

export default TextCtaType;
